var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.isNull)?_c('span'):(_vm.isUnknown)?_c('span',{staticClass:"dimension-cell"},[_vm._v("Unknown")]):(!_vm.dimension.id)?_c('span',{staticClass:"dimension-cell"},[_vm._v(_vm._s(_vm.dimension.description))]):_c('span',{staticClass:"dimension-cell"},[_vm._v(_vm._s(_vm.dimension.id)+" "+_vm._s(_vm.dimension.description))])
}
var staticRenderFns = []

export { render, staticRenderFns }